module.exports = __webpack_public_path__ + "static/media/bgEditWorkoutPage.3d92c4f9.jpg";